import { ModuleRequestError } from './request-error.js';
/**
 * Ошибку раздела — словами (одно правило на все `admin-module-*`). `mode:
 * 'write'` — для мутаций: 403 там значит «смотреть можно, менять нельзя».
 * Порядок: 403 → «не подключён» → свои исходы раздела (`extra`) → отказ
 * апстрима (`upstream_rejected`: русская фраза admin-api, как есть) → 502/503/504
 * «недоступен» → «Не удалось загрузить/выполнить: <текст>».
 * Не `ModuleRequestError` — то же с `Error.message`.
 */
export function describeModuleError(err, mode, opts) {
    const prefix = mode === 'write' ? 'Не удалось выполнить' : 'Не удалось загрузить';
    if (!(err instanceof ModuleRequestError)) {
        return `${prefix}: ${err instanceof Error ? err.message : String(err)}`;
    }
    const textOf = opts.textOf ?? ((e) => e.serverMessage ?? e.code);
    if (err.status === 403)
        return mode === 'write' ? opts.forbiddenWrite : opts.forbiddenRead;
    if (err.code === opts.notConfiguredCode)
        return opts.notConfiguredText;
    const own = opts.extra?.(err);
    if (own != null)
        return own;
    if (err.code === 'upstream_rejected')
        return textOf(err);
    if (err.status === 502 || err.status === 503 || err.status === 504)
        return opts.unavailableText;
    return `${prefix}: ${textOf(err)}`;
}
//# sourceMappingURL=describe-error.js.map